import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=76c7c7a0"
import script from "./navmenu.ts?vue&type=script&lang=js&external"
export * from "./navmenu.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c7c7a0')) {
      api.createRecord('76c7c7a0', component.options)
    } else {
      api.reload('76c7c7a0', component.options)
    }
    module.hot.accept("./navmenu.vue?vue&type=template&id=76c7c7a0", function () {
      api.rerender('76c7c7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/navmenu/navmenu.vue"
export default component.exports